export const NURSING_HOME_PLAY_STORE_LINK =
  'https://play.google.com/store/apps/details?id=at.pflegenavi.nursinghome';
export const NURSING_HOME_APP_STORE_LINK =
  'https://apps.apple.com/us/app/pflegenavi-nursing-home/id6443740109';
// TODO: replace with family member play store link once available
export const FAMILY_MEMBER_PLAY_STORE_LINK =
  'https://play.google.com/store/apps/details?id=at.pflegenavi.familymember';
export const FAMILY_MEMBER_APP_STORE_LINK =
  'https://apps.apple.com/us/app/pflegenavi-family-member/id6443876593';
